import { WWOTopLinkDestinationsTable } from "app/pages/website-performance/components/TopLinkDestinations/WWOTopLinkDestinationsTable";
import { DEFAULT_HOOKS_MODAL_ID } from "app/pages/workspace/config/stateToWsConfigMap";
import { proNavigator } from "single-spa/react-app/ProNavigator";

export const WWOTopLinkDestinationsContainerSI = () => {
    const params = proNavigator.getParams();

    const getCtaLink = () => {
        return {
            href: proNavigator.href("accountreview_website_outgoingtraffic", params),
            target: "_self",
        };
    };
    return (
        <WWOTopLinkDestinationsTable
            getCtaLink={getCtaLink}
            unlockHook={{
                component: "WebReferralOutgoingTraffic",
                hookModal: DEFAULT_HOOKS_MODAL_ID,
            }}
        />
    );
};
